import { useAppSelector } from '@app/redux/hooks';
import { getBusinessIntegrations } from '@app/services/integrations';
import { useQuery } from '@tanstack/react-query';

export const useSelectBusinessPage = () => {
  const businessState = useAppSelector((state) => state.business);
  const user = useAppSelector((state) => state.auth.user);
  // Ensure we always have a consistent array length to prevent hooks error
  const businessList = businessState?.list || [];
  
  // Create a fixed number of queries (max 10 businesses to prevent too many hooks)
  const maxBusinesses = 10;
  const businessIntegrationsQueries = Array.from({ length: maxBusinesses }, (_, index) => {
    const business = businessList[index];
    
    return useQuery({
      queryKey: ['business-integrations', business?.id || `empty-${index}`, index],
      queryFn: () => business ? getBusinessIntegrations(business.id) : Promise.resolve(null),
      enabled: !!business?.id,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      staleTime: 0, // Always fetch fresh data
    });
  });

  // Create a map of business ID to integrations
  const businessIntegrationsMap = businessList.reduce((acc, business, index) => {
    const query = businessIntegrationsQueries[index];
    if (query?.data?.data?.integrations) {
      acc[business.id] = query.data.data.integrations;
    } else {
      acc[business.id] = [];
    }
    return acc;
  }, {} as Record<string, any[]>) || {};


  return {
    businessState,
    businessIntegrationsMap,
    isLoadingIntegrations: businessIntegrationsQueries.some((query) => query.isLoading),
    user,
  };
};
